import { useEffect } from "react";
import axios from "axios";
import Pusher, { Channel } from "pusher-js";

// import {PUSHER_CLUSTER, PUSHER_KEY} from 'react-native-dotenv';

export type PusherEventBinding = {
  eventName: string;
  eventCallback: (payload?: any) => void;
};

let pusher: Pusher | null = null;

export const initialisePusher = () => {
  pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY || "", {
    cluster: process.env.REACT_APP_PUSHER_CLUSTER || "",
  });
  pusher.connection.bind("connected", () => {
    axios.defaults.headers.common["socket-id"] = pusher?.connection.socket_id;
    // axios.defaults.headers.common["socket-id"] = pusher?.connection.socket_id;
  });
};

/**
 * A Hook to connect/disconnect pusher event/callback for using channel
 * @pusherEventBindings - A event object which container list of event names and its callback implementation
 * @channelName - channel name against the pusher channel to be subscribed
 * @pusherDependencies - List of pusher dependencies to update the pusher connection based on its states
 */
export const usePusher = (
  pusherEventBindings: PusherEventBinding[],
  channelName: string,
  pusherDependencies: Array<any> = []
): void => {
  useEffect(() => {
    const channel: Channel | undefined = pusher?.subscribe(channelName);

    pusherEventBindings.forEach((pusherEvent) => {
      const { eventCallback, eventName } = pusherEvent;
      channel?.bind(eventName, eventCallback);
    });

    return () => {
      if (channel && pusher) {
        channel.disconnect();
        pusher?.unsubscribe(channelName);
      }
    };
  }, [...pusherDependencies]);
};
